import destroyedsecureImage from '../assets/images/destroyedsecure.avif';
import fhabricImage from '../assets/images/Fhabric.png';
import vestigiumImage from '../assets/images/Vestigiumnapoca.avif';
import reginaDinTribunaImage from '../assets/images/rdt2.png';

export const projects = [
    {
        id: 1,
        image: reginaDinTribunaImage,
        title: 'Regina din Tribuna',
        tags: ['Django', 'Tailwind', 'Alpine.js', 'Sports API'],
        description: 'Editorial sports betting platform built for Regina din Tribuna. Developed with a Django backend and a Tailwind CSS / Alpine.js frontend, integrating a live sports data API to power editorial content, match insights, and betting-focused articles.',
        link: 'https://reginadintribuna.ro',
        hasLink: true,
        imageFit: 'contain',
    },
    {
        id: 2,
        image: fhabricImage,
        title: 'FHabric',
        tags: ['Astro'],
        description: 'Presentation website for FHabric, a hair craft academy. Built in Astro with a clean brand-led interface, responsive layout, and a structure focused on clearly presenting the academy and its offerings.',
        link: 'https://fhabric.ro',
        hasLink: true,
        imageFit: 'contain',
    },
    {
        id: 4,
        image: destroyedsecureImage,
        title: 'Destroyed Secure',
        tags: ['Astro', 'Cloudflare'],
        description: 'Complete redesign of a Romanian data destruction and secure document shredding business website. Built as a static site with Astro, featuring bilingual support (RO/EN), SEO optimization, and deployed on Cloudflare Pages.',
        link: 'https://destroyedsecure.ro',
        hasLink: true,
    },
    {
        id: 5,
        image: vestigiumImage,
        title: 'Vestigium Napoca',
        tags: ['Astro', 'Astro Framework', 'Branding', 'Social Media'],
        description: 'Presentation website and complete branding for Vestigium Napoca, a private detective agency in Cluj-Napoca. Built as a static site in Astro, alongside comprehensive branding including logo design and social media presence.',
        link: 'https://vestigiumnapoca.ro',
        hasLink: true,
    },
];
